import Link from "@mui/material/Link";
import { useInnerCrudContext } from "./useInnerCrudContext";

export interface InnerCrudLinkProps {
  children?: React.ReactNode;
  id: string;
}

export function InnerCrudLink({ children, id }: InnerCrudLinkProps) {
  const context = useInnerCrudContext();
  const setId =
    typeof context === "object" && context
      ? context.setId
      : () => {
          //
        };

  const onClick = (event: React.MouseEvent) => {
    event.preventDefault();
    setId(id);
  };

  return (
    <Link onClick={onClick} underline="hover" color="secondary" href="#edit">
      {children}
    </Link>
  );
}
